/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import Reaptcha from 'reaptcha';
import QueryString from 'query-string';
import { useHistory } from 'react-router-dom';
import { FadeLoader } from 'react-spinners';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEmpty } from 'lodash';
import $ from 'jquery';

import { setVarFromJSON } from 'utils/general';
import { postInvoicePayment, getPaymentAuthToken } from 'api/fullsteam';
import { styledTheme } from 'globalStyles/theme';
import { useEvent } from 'hooks/useEvent';
import InfoButton from 'components/Button/InfoButton';
import APFormGroup from 'components/FormFields/APFormGroup';
import InputField from 'components/FormFields/InputField';
import SevenCCLogos from 'assets/images/payment_methods/7-cc-logos.png';
import Country from './Components/country';
import ErrorModal from './ErrorModal';
import PaymentModal from './PaymentModal';
import ConfirmModal from './ConfirmModal';
import PaymentMethod from './Components/PaymentMethod';

import './styles.scss';

window.jQuery = $;
const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_KEY;


function PaymentForm() {
  const [disableSubmit, setDisableSubmit] = useState(false);
  // reponse/error from fullsteam.js
  const [errMessage, setErrorMessage] = useState(null);
  const [gResponse, setResponse] = useState(null);

  // show success/error modal
  const [toggleErrModal, showErrModal] = useState(false);
  const [isTransactionSucceed, setTransactionSuccess] = useState(false);
  const [isBadRequest, setBadRequest] = useState(false);

  // form is submitted to fullsteam and get the result
  const [isSubmitted, setSubmitted] = useState(false);
  const [isPageReloaded, setPageLoaded] = useState(false);

  // customer details
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [verified, setVerified] = useState(false);
  const [country, setCountry] = useState('US');


  // Getting the params which comes from fullsteam
  const history = useHistory();
  const pathname = history.location?.pathname;
  const params = QueryString.parse(history.location?.search);

  const invoiceId = pathname.replace('/app/v2/invoice/pay/', '').replace('/process', '');
  const invoiceData = localStorage.getItem('invoice');
  const invoice = setVarFromJSON(invoiceData);

  const {
    method,
    authenticationKey: authKey,
    expirationDateUtc: expiredDate,
    invoiceDetail = {},
    amount = 0,
    creditAmount,
    creditFeeAmount,
    achAmount,
    achFeeAmount,
    disableDupDetection = false,
  } = invoice;
  const {
    identifier = '',
    ach_fee,
    credit_fee,
    accepts_credit_platform_fee: acceptsCreditPlatform,
    accepts_ach_platform_fee: acceptsAchPlatformFee,
    currency,
  } = invoiceDetail;
  const chargeAmount = (method === 'credit' && acceptsCreditPlatform)
    ? creditAmount : (method === 'ach' && acceptsAchPlatformFee) ? achAmount : amount;
  const invoiceNum = identifier.substring(0,20);

  // We only want to show platform fee field items if the current method has an applicable fee.
  const hasPlatformFee = (method === 'ach' && acceptsAchPlatformFee) || (method === 'credit' && acceptsCreditPlatform);
  const platformFee = method === 'ach' ? ach_fee : method === 'credit' ? credit_fee : 0;
  const feeToBeCollected = method === 'ach' ? achFeeAmount : method === 'credit' ? creditFeeAmount : 0;

  useEvent('load', () => {
    setPageLoaded(true);
  });

  useEffect(() => {
    if (expiredDate && (new Date() > new Date(expiredDate))) history.push(`/app/v2/invoice/pay/${invoiceId}`);
  }, [expiredDate]);

  useEffect(() => {
    if (errMessage || gResponse) {
      showErrModal(true);
    }
  }, [errMessage, gResponse]);

  useEffect(() => {
    const handleInvoicePayment = async (body) => {
      const response = await postInvoicePayment({ invoiceId, body });
      if (response?.status === 200) {
        setTransactionSuccess(true);
      } else if (response?.status === 400) {
        // handle for the failed webhook
        setBadRequest(true);
      }
    };

    if (!isEmpty(params) && !isTransactionSucceed) {
      const {
        HostedPaymentsResponse,
        NameOnAccount,
        Address1,
        City,
        State,
        Zip,
        Country: countryValue,
        Email,
        amount: originalAmount,
        'platform-fee': _platformFee,
        'platform-rate': platformRate,
      } = params;

      const customerData = {
        name: NameOnAccount,
        address: Address1,
        city: City,
        email: Email,
        state: State,
        zip: Zip,
        country: countryValue,
      };
      const bodyData = setVarFromJSON(HostedPaymentsResponse[0]);
      if (bodyData) {
        bodyData.customer = customerData;
        bodyData.method = method;
        bodyData.requestDetails.invoiceNumber = String(bodyData.requestDetails.customerId);
        bodyData.originalAmount = parseFloat(originalAmount);
        bodyData.platformFee = parseFloat(_platformFee);
        bodyData.platformRate = parseFloat(platformRate);
        handleInvoicePayment(bodyData);
      }
    }

    if (currency === 'CAD') {
      setCountry('CA');
    }
  }, []);

  const onMethodSelect = async (option) => {
    if (option === method) return;

    const changedData = {
      authenticationKey: authKey,
      expirationDateUtc: expiredDate,
      invoiceDetail,
      amount,
      creditAmount,
      creditFeeAmount,
      achAmount,
      achFeeAmount,
      disableDupDetection,
      method: option,
    };

    if (option === 'cash') {
      localStorage.setItem('invoice', JSON.stringify(changedData));
      history.go(0);
      return;
    }
    const newMethodAmount = (option === 'credit' && acceptsCreditPlatform)
    ? creditAmount : (option === 'ach' && acceptsAchPlatformFee) ? achAmount : amount;
    const authResponse =  await getPaymentAuthToken(invoiceId, { amount: `${newMethodAmount}` });

    if (authResponse) {
      const authenticationKey = authResponse?.data?.fs_response?.authenticationKey;
      const expirationDateUtc = authResponse?.data?.fs_response?.expirationDateUtc;
      const disableDupDetection1 = authResponse?.data?.disable_duplicate_detection || disableDupDetection;
      if (authenticationKey) {
        localStorage.setItem('invoice', JSON.stringify({
          ...changedData,
          authenticationKey,
          expirationDateUtc,
          disableDupDetection: disableDupDetection1,
        }));
      }
    }
    history.go(0);
  };

  const onVerify = () => {
    setVerified(true);
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDisableSubmit(true);
    setSubmitted(true);
    if (name && email && address && city && state && zipcode) {
      $('#payment-form').submit();
      e.preventDefault();
      e.stopPropagation();
    } else {
      setDisableSubmit(false);
    }
  };

  const renderPaymentCash = () => (
    <article className="payment-options_check">
      <div>Thank you for selecting payment by cash or check.
        Please reference your invoice for payment information.</div>
    </article>
  );

  if (!authKey) history.push(`/app/v2/invoice/pay/${invoiceId}`);

  return (
    <>
      <PaymentModal
        invoiceId={invoiceId}
        opacity={!isPageReloaded && !isEmpty(params) ? 0.8 : 1}
        onClose={() => {
          window.location.href = `/invoice/view/${invoiceId}`;
        }}
      >
        {!isPageReloaded && !isEmpty(params) && (
          <section className="app_loader">
            <FadeLoader
              color={styledTheme.lighterGray}
              loading
              height={15}
              width={5}
              radius={5}
              margin={2}
            />
          </section>
        )}
        <div className="body-content container--small">
          <div className="payment-options">
            <div className="payment-options__title">
              <h3>Select Payment Method</h3>
            </div>
            <section className="payment-options_selector">
              {invoiceDetail.isCredit && (
                <div className={clsx('payment-options_option', {
                  'selected': method === 'credit',
                })}
                >
                  <div
                    onClick={() => onMethodSelect('credit')}
                    className="card"
                  >
                    <FontAwesomeIcon
                      icon={['fal', 'credit-card']}
                      size="3x"
                      className="payment-options__icon"
                    />
                  </div>
                  <div className="card-title">Credit Card</div>
                </div>
              )}
              {invoiceDetail.isACH && (
                <div className={clsx('payment-options_option', {
                  'selected': method === 'ach',
                })}
                >
                  <div
                    onClick={() => {
                      onMethodSelect('ach');
                    }}
                    className="card"
                  >
                    <FontAwesomeIcon
                      icon={['fal', 'exchange']}
                      size="3x"
                      className="payment-options__icon"
                    />
                  </div>
                  <div className="card-title">Bank Transfer</div>
                </div>
              )}
              {invoiceDetail.isCheck && (
                <div className={clsx('payment-options_option', {
                  'selected': method === 'cash',
                })}
                >
                  <div
                    onClick={() => {
                      onMethodSelect('cash');
                    }}
                    className="card"
                  >
                    <FontAwesomeIcon
                      icon={['fal', 'usd-circle']}
                      size="3x"
                      className="payment-options__icon"
                    />
                  </div>
                  <div className="card-title">Cash/Check</div>
                </div>
              )}
            </section>
          </div>
          <hr />
          <form
            id="payment-form"
            className="payment-form"
          >
            {method === 'cash' ? renderPaymentCash() : (
              <>
                {method === 'ach' && (
                  <article className="payment-options_check" />
                )}
                <div className="panel panel-default">
                  <div className="panel-body">
                    <APFormGroup
                      gridGap={1}
                      verticalGap={0}
                    >
                      <InputField
                        className={clsx({ 'input-error': isSubmitted && !name })}
                        data-val="true"
                        data-val-length="The field Name on Account must be a string with a maximum length of 50."
                        data-val-length-max="50"
                        data-val-required="The Name on Account field is required."
                        id="NameOnAccount"
                        maxLength="50"
                        name="NameOnAccount"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        label="Name on Card/Bank Account"
                      />
                      <InputField
                        className={clsx({ 'input-error': isSubmitted && !email })}
                        type="email"
                        data-val="true"
                        data-val-email="The Email field is not a valid email address."
                        data-val-length="The field Email must be a string with a maximum length of 70."
                        data-val-length-max="70"
                        id="Email"
                        maxLength="70"
                        name="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        label="Cardholder/Bank Account Email"
                      />

                    </APFormGroup>
                    <PaymentMethod
                      method={method}
                      authKey={authKey}
                      disableDupDetection={disableDupDetection}
                      chargeAmount={chargeAmount}
                      identifier={identifier}
                      setErrorMessage={setErrorMessage}
                      setResponse={setResponse}
                      setDisableSubmit={setDisableSubmit}
                    />
                    {method === 'credit' && (
                      <img
                        src={SevenCCLogos}
                        className="payment-form__cc-logos"
                      />
                    )}
                    <hr />
                    <APFormGroup
                      verticalGap={0}
                    >
                      <div className="form-item form-item--w-100">
                        <label className="control-label text-uppercase">Address Line 1</label>
                        <input
                          type="text"
                          className={clsx({ 'input-error': isSubmitted && !address })}
                          data-val="true"
                          data-val-length="The field Address Line 1 must be a string with a maximum length of 50."
                          data-val-length-max="50"
                          id="Address1"
                          maxLength="50"
                          name="Address1"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                        />
                        <span className="text-danger field-validation-valid"
                          data-valmsg-for="Address1"
                          data-valmsg-replace="true"
                        />
                      </div>
                    </APFormGroup>
                    <APFormGroup
                      gridGap={1}
                      className="ap-form-group--address"
                    >
                      <div className="form-item form-item--city">
                        <label className="control-label text-uppercase">City</label>
                        <input
                          type="text"
                          className={clsx({ 'input-error': isSubmitted && !city })}
                          data-val="true"
                          data-val-length="The field City must be a string with a maximum length of 30."
                          data-val-length-max="30"
                          id="City"
                          maxLength="30"
                          name="City"
                          value={city}
                          onChange={(e) => setCity(e.target.value)}
                        />
                        <span className="text-danger field-validation-valid"
                          data-valmsg-for="City"
                          data-valmsg-replace="true"
                        />
                      </div>

                      <div className="form-item form-item--state">
                        <label className="control-label text-uppercase">
                          {country === 'CA' ? 'Province' : 'State'}
                        </label>
                        <input
                          type="text"
                          className={clsx({ 'input-error': isSubmitted && !state })}
                          data-val="true"
                          data-val-length="The field State must be a string with a maximum length of 2."
                          data-val-length-max="2"
                          id="State"
                          maxLength="2"
                          name="State"
                          value={state}
                          onChange={(e) => setState(e.target.value.toUpperCase())}
                        />
                        <span className="text-danger field-validation-valid"
                          data-valmsg-for="State"
                          data-valmsg-replace="true"
                        />
                      </div>

                      <div className="form-item form-item--zip">
                        <label className="control-label text-uppercase">Postal Code</label>
                        <input
                          type="text"
                          className={clsx({ 'input-error': isSubmitted && !zipcode })}
                          data-val="true"
                          data-val-length="The field Postal code must be a string with a maximum length of 20."
                          data-val-length-max="20"
                          id="Zip"
                          maxLength="20"
                          name="Zip"
                          data-val-required="The Postal code field is required."
                          value={zipcode}
                          onChange={(e) => setZipcode(e.target.value)}
                        />
                        <span className="text-danger field-validation-valid"
                          data-valmsg-for="Zip"
                          data-valmsg-replace="true"
                        />
                      </div>

                      <div className="form-item ap-select form-item--country">
                        <label className="control-label text-uppercase">Country</label>
                        <div className="ap-select">
                          <Country
                            data-val="true"
                            data-val-length="The field Country must be a string with a maximum length of 2."
                            data-val-length-max="2"
                            id="Country"
                            maxLength="50"
                            name="Country"
                            value={country}
                            onChange={(e) => {
                              setCountry(e.target.value);
                            }}
                          />
                          <FontAwesomeIcon
                            icon="chevron-down"
                            className="select-icon"
                          />
                        </div>
                        <span className="form-item__error field-validation-valid"
                          data-valmsg-for="Country"
                          data-valmsg-replace="true"
                        />
                      </div>
                    </APFormGroup>
                    <hr />
                    <APFormGroup
                      verticalGap={0}
                    >
                      <div className="form-item">
                        <label className="control-label text-uppercase">
                          {`Payment Amount (${currency === 'CAD' ? currency : 'USD'})`}
                        </label>
                        <input
                          data-val="true"
                          id="amount"
                          name="amount"
                          type="number"
                          defaultValue={amount}
                          readOnly
                        />
                        <span className="form-item__error field-validation-valid"
                          data-valmsg-for="amount"
                          data-valmsg-replace="true"
                        />
                      </div>
                    </APFormGroup>
                    {hasPlatformFee && (
                      <APFormGroup
                        gridGap={1}
                      >
                        <div className="form-item form-item--platform-fee">
                          <label className="control-label text-uppercase">
                            {`Platform Fee (${platformFee}%)`}
                          </label>
                          <InfoButton
                            mode='tooltip'
                            tooltipProps={{
                              message: 'This Platform Fee is nonrefundable',
                              tooltipDelay: 50,
                              floatingProps: {
                                placement: 'top',
                              },
                            }}
                          />
                          <input
                            data-val="true"
                            id="platform-fee"
                            name="platform-fee"
                            type="number"
                            defaultValue={feeToBeCollected}
                            readOnly
                          />
                        </div>
                        <input type="hidden"
                          name="platform-rate"
                          id="platform-rate"
                          defaultValue={platformFee}
                        />
                        <div className="form-item form-item--total">
                          <label className="control-label text-uppercase">Total Amount</label>
                          <input
                            data-val="true"
                            id="total-amount"
                            name="total-amount"
                            type="number"
                            defaultValue={chargeAmount.toFixed(2)}
                            readOnly
                          />
                        </div>
                      </APFormGroup>
                    )}
                    <input type="hidden"
                      name="TransactionId"
                      id="TransactionId"
                    />
                    <input type="hidden"
                      name="AccountToken"
                      id="AccountToken"
                    />
                    <input type="hidden"
                      name="HostedPaymentsResponse"
                      id="HostedPaymentsResponse"
                    />
                  </div>
                </div>
              </>
            )}

            {method !== 'cash' && RECAPTCHA_SITE_KEY && (
              <div className="payment-form__recaptcha">
                <Reaptcha
                  sitekey={RECAPTCHA_SITE_KEY}
                  onVerify={onVerify}
                />
              </div>
            )}
            <div className="form-item">
              <input type="hidden"
                name="InvoiceId"
                id="InvoiceId"
                value={invoiceNum}
              />
            </div>
            <div className="form-item">
              <input type="hidden"
                name="TransactionId"
                id="TransactionId"
              />
            </div>
            <div className="form-item">
              <input type="hidden"
                name="AccountToken"
                id="AccountToken"
              />
            </div>
            <div className="form-item">
              <input type="hidden"
                name="HostedPaymentsResponse"
                id="HostedPaymentsResponse"
              />
            </div>
            {method !== 'cash' && (
              <div className="form-item form-item--submit payment-form__actions">
                <input
                  type="button"
                  value="Cancel"
                  onClick={() => history.push(`/app/v2/invoice/pay/${invoiceId}`)}
                  className="payment-form__submit-button button button--outline button--lg"
                />
                <input
                  type="button"
                  value={`Make Payment ($${chargeAmount.toFixed(2)})`}
                  className="payment-form__submit-button button button--lg"
                  id="submitButton"
                  disabled={!verified || disableSubmit}
                  onClick={onSubmitHandler}
                />
              </div>
            )}
            <div className="payment-form__legal">
              <a href="https://www.aisleplanner.com/legal"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Service
              </a>
              &nbsp;|&nbsp;
              <a href="https://www.aisleplanner.com/legal#privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </div>
          </form>
        </div>
      </PaymentModal>
      <ErrorModal
        open={toggleErrModal}
        onClose={() => showErrModal(false)}
      >
        <div className="body-content container--small">
          <div>{errMessage}</div>
          <div>{gResponse?.issuerResponseDetails?.issuerResponseDescription}</div>
        </div>
      </ErrorModal>
      <ConfirmModal
        open={isTransactionSucceed && isPageReloaded}
        onClose={() => {
          window.location.href = `/invoice/view/${invoiceId}`;
        }}
      >
        <div className="body-content container--small">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center">
                <h3>Thank you for your payment.</h3>
                <input
                  type="button"
                  value="Return To Invoice"
                  className="submit_button button button--lg mt-5"
                  onClick={() => {
                    window.location.href = `/invoice/view/${invoiceId}`;
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </ConfirmModal>
      <ConfirmModal
        open={isBadRequest && isPageReloaded}
        onClose={() => {
          window.location.href = `/invoice/view/${invoiceId}`;
        }}
      >
        <div className="body-content container--small">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center">
                <h3>Thank you for your payment.</h3>
                <p className="mt-4">Payments may take some time to appear on your invoice.
                  If your invoice has not been updated within 24 hours, please contact your merchant.
                </p>
                <input
                  type="button"
                  value="Return To Invoice"
                  className="submit_button button button--lg mt-5"
                  onClick={() => {
                    window.location.href = `/invoice/view/${invoiceId}`;
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </ConfirmModal>
    </>
  );
}

export default PaymentForm;
